export default __webpack_public_path__ + "static/media/Sweet Potato Fries_ proportioned_170.d7abd455.jpg";